// Capture-asset resolution (WS2). Feedback records and package screens now
// reference their capture instead of embedding the raster; the API serves the
// image at /api/feedback/capture-assets/... from S3 (reference mode) or from
// the stored package (embedded mode). Pre-existing records that still embed a
// data URL render it directly — but only when it is actually an image data
// URL, never an arbitrary remote URL a source could have injected (W-m9).

const IMAGE_DATA_URL_PATTERN = /^data:image\//i;

export function captureAssetUrl({ environmentId, packageId, screenId, kind = 'screenshot' }) {
  if (!packageId || !screenId) return null;
  const segment = (value) => encodeURIComponent(String(value));
  return `/api/feedback/capture-assets/${segment(environmentId || 'local')}/${segment(packageId)}/${segment(screenId)}/${segment(kind)}`;
}

// Resolves the image source for a feedback record's screenContext (queue
// detail, reporter surfaces). Returns null when nothing renderable exists.
export function captureImageSource(screenContext, { environmentId } = {}) {
  if (!screenContext || typeof screenContext !== 'object') return null;
  const dataUrl = screenContext.screenshotDataUrl;
  if (typeof dataUrl === 'string' && dataUrl) {
    return IMAGE_DATA_URL_PATTERN.test(dataUrl) ? dataUrl : null;
  }
  if (screenContext.screenshotRef || screenContext.captureStorage) {
    return captureAssetUrl({
      environmentId,
      packageId: screenContext.packageId,
      screenId: screenContext.screenId,
      kind: 'screenshot',
    });
  }
  return null;
}

// Resolves the image source for a package screen (workspace replay, session
// tray). Same fallback order as captureImageSource.
export function screenImageSource(screen, { environmentId, packageId } = {}) {
  if (!screen || typeof screen !== 'object') return null;
  const dataUrl = screen.screenshotDataUrl;
  if (typeof dataUrl === 'string' && dataUrl) {
    return IMAGE_DATA_URL_PATTERN.test(dataUrl) ? dataUrl : null;
  }
  if (screen.screenshotRef || screen.captureStorage === 'reference') {
    return captureAssetUrl({
      environmentId,
      packageId,
      screenId: screen.screenId || screen.id,
      kind: 'screenshot',
    });
  }
  return null;
}
